import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";
import * as PropTypes from "prop-types";

import { cn } from "@/lib/utils";

interface ProgressProps {
  className?: string;
  value: number;
}

const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ className, value, ...props }, ref) => {
    Progress.propTypes = {
      value: PropTypes.number.isRequired,
    };

    return (
      <ProgressPrimitive.Root
        ref={ref}
        className={cn(
          "relative h-4 w-full overflow-hidden rounded-md bg-background",
          className
        )}
        {...props}
      >
        <ProgressPrimitive.Indicator
          className="h-full w-full flex-1 bg-accent transition-all"
          style={{
            transform: `translateX(-${(100 - value).toString()}%)`
          }}
        />
      </ProgressPrimitive.Root>
    );
  }
);
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
